import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/statistic.svg';

export const IconStatistic = createIconComponent(Icon);
